<template>
	<button
		class="settings-button"
		:class="{
			'settings-button--large': props.size === 'large',
			'settings-button--medium': props.size === 'medium',
			'settings-button--small': props.size === 'small',
			'settings-button--default': props.theme === 'default',
			'settings-button--danger': props.theme === 'danger',
			'settings-button--warning': props.theme === 'warning',
			'settings-button--inverted': props.theme === 'inverted',
			'settings-button--secondary': props.theme === 'secondary',
			'settings-button--full-width': props.fullWidth,

		}"
		:disabled="props.disabled"
		:type="props.type"
	>
		<slot />
	</button>
</template>

<script setup lang="ts">
type Props = {
	size?: 'large' | 'medium' | 'small';
	theme?: 'default' | 'inverted' | 'danger' | 'warning' | 'secondary';
	type?: 'button' | 'submit';
	disabled?: boolean;
	fullWidth?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
	size: 'large',
	theme: 'default',
	type: 'button',
});
</script>

<style scoped lang="scss">
.settings-button {
	margin-top: 0;
	border: 1px solid;
	text-transform: uppercase;
	cursor: pointer;

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}

	&--large {
		padding: 1.4rem 2.5rem;
		font-size: 1.3rem;
		letter-spacing: 2.5px;
	}

	&--medium {
		padding: 0.5rem 1.4rem;
		font-size: 1.3rem;
		letter-spacing: 2.5px;
	}

	&--small {
		padding: 0.3rem 1rem;
		font-size: 1rem;
		letter-spacing: 1px;
	}

	&--default {
		border-color: $primary;
		background-color: $transparentPrimary;
		color: $primary;

		&:not(:disabled):hover {
			background-color: $primary;
			color: white;
		}
	}

	&--danger {
		border-color: $error;
		background-color: $transparentError;
		color: $error;

		&:not(:disabled):hover {
			background-color: $error;
			color: white;
		}
	}

	&--warning {
		border-color: $warning;
		background-color: $transparentWarning;
		color: $warning;

		&:not(:disabled):hover {
			background-color: $warning;
			color: white;
		}
	}

	&--inverted {
		border-color: white;
		color: white;

		&:not(:disabled):hover {
			background-color: white;
		}
	}

	&--secondary {
		border-color: $secondary;
		background-color: $transparentGrey;
		color: $secondary;

		&:not(:disabled):hover {
			background-color: $secondary;
			color: white;
		}
	}

	&--full-width { width: 100%; }
}
</style>
